export enum SortOption {
    'newest' = 'newest',
    'oldest' = 'oldest',
    'positive' = 'positive',
    'negative' = 'negative',
}
